export enum ChannelName {
  PUBLIC = 'public-channel',
  PRIVATE = 'private-channel',
}

export enum EventTypes {
  PUBLIC = 'public-event',
  PRIVATE = 'private-event',
}
